/* Nomari product photo slider + full-screen zoom viewer (2026-09-30). No dependencies.
   NomariGallery.slider(el, items, {ratio, onOpen, sizes})  (sizes = <img sizes> for the responsive srcset, 2026-10-02 perf) → {goTo(i, smooth), index()}
   NomariGallery.zoom(items, start)
   item = {src: "img/name" (extension-less; .webp + .jpg exist), alt, caption?, placeholder?}
   opts.links (home featured slider, 2026-10-02): each item {src, alt, href, open, labelHtml} renders as a link (no zoom) with its photo in a
   ratio box (opts.ratio, object-fit contain) and a label strip under the photo (bottom-left); swipe, arrows, dots and counter are unchanged.
   Slides 2+ show a caption pill (caption || alt); caption: false = no pill (e.g. posters with their own title text). Slide 1 NEVER shows a caption (Atash's standing rule). */
(function(){
  "use strict";
  var C = window.NOMARI_CONFIG || {};
  var asset = function(src, ext){ return C.assetUrl ? C.assetUrl(src, ext) : src + ext; };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); };
  function picture(it, eager){
    if (!it.src) return '<div class="g-ph" role="img" aria-label="相片準備中">相片準備中<small>Photo coming soon</small></div>';
    return '<picture><source type="image/webp" srcset="'+esc(asset(it.src, '.webp'))+'"><img src="'+esc(asset(it.src, '.jpg'))+'" alt="'+esc(it.alt||"")+'" '+
      (eager ? 'fetchpriority="high"' : 'loading="lazy"')+' decoding="async" draggable="false"></picture>';
  }
  // inline slider slides (2026-10-02 perf): responsive srcset/sizes via img.js; slide 1 eager + fetchpriority=high,
  // slides 2+ parked (data-src) and hydrated on first interaction / when they become current or a neighbour.
  function slidePicture(it, i, opts){
    if (!it.src || !window.NomariImg) return picture(it, i === 0);
    return window.NomariImg.picture(it.src, it.alt, {sizes: opts.sizes, eager: i === 0, defer: i > 0, attrs: 'draggable="false"'});
  }
  function trackIndex(track){ var w = track.clientWidth || 1; return Math.max(0, Math.round(track.scrollLeft / w)); }
  function scrollToIdx(track, i, smooth){
    track.scrollTo({left: i * track.clientWidth, behavior: smooth ? "smooth" : "auto"});
  }

  // ---------------- inline slider ----------------
  function slider(el, items, opts){
    opts = opts || {};
    // fresh element each time (drops listeners from a previous product page)
    var fresh = el.cloneNode(false); el.parentNode.replaceChild(fresh, el); el = fresh;
    var n = items.length, multi = n > 1;
    el.className = "gs" + (multi ? "" : " gs-single") + (opts.links ? " gs-links" : "");
    el.setAttribute("role", "region"); el.setAttribute("aria-roledescription", "carousel"); el.setAttribute("aria-label", opts.label || "產品相片 Photos");
    el.innerHTML =
      '<div class="gs-track" tabindex="0"'+(opts.links ? '' : ' style="aspect-ratio:'+esc(opts.ratio || "1 / 1")+'"')+'>' +
      items.map(function(it, i){
        if (opts.links) return '<div class="gs-slide" role="group" aria-roledescription="slide" aria-label="'+(i+1)+' / '+n+'" data-i="'+i+'">' +
          '<a class="gs-link" href="'+esc(it.href)+'" data-home-open="'+esc(it.open)+'" draggable="false"><span class="gs-media" style="aspect-ratio:'+esc(opts.ratio || "1 / 1")+'">'+slidePicture(it, i, opts)+'</span>' +
          '<span class="gs-label">'+(it.labelHtml || "")+'</span></a></div>';
        return '<div class="gs-slide" role="group" aria-roledescription="slide" aria-label="'+(i+1)+' / '+n+'" data-i="'+i+'">' +
          '<button type="button" class="gs-open" data-i="'+i+'" aria-label="放大睇 Zoom">'+slidePicture(it, i, opts)+(i > 0 && it.caption !== false && (it.caption || it.alt) ? '<span class="gs-caption">'+esc(it.caption || it.alt)+'</span>' : '')+'</button>' + '</div>';
      }).join("") + '</div>' +
      (multi ? '<button type="button" class="gs-nav gs-prev" aria-label="上一張 Previous">‹</button><button type="button" class="gs-nav gs-next" aria-label="下一張 Next">›</button>' +
        '<div class="gs-dots">' + items.map(function(_, i){ return '<button type="button" data-dot="'+i+'" aria-label="第 '+(i+1)+' 張"></button>'; }).join("") + '</div>' +
        '<span class="gs-count" aria-hidden="true"></span>' : '') +
      (opts.links ? '' : '<span class="gs-zoomhint" aria-hidden="true">⤢</span>');
    var track = el.querySelector(".gs-track"), cur = -1;
    function hyd(i){ [i - 1, i, i + 1].forEach(function(k){ var s = (k >= 0 && k < n) && el.querySelector('.gs-slide[data-i="'+k+'"]'); if (s && window.NomariImg) window.NomariImg.hydrate(s); }); }
    var touched = false;
    function wake(){ if (touched) return; touched = true; hyd(Math.max(0, trackIndex(track))); }
    ["pointerdown", "touchstart", "mouseenter", "focusin", "wheel"].forEach(function(ev){ el.addEventListener(ev, wake, {passive: true}); });
    function sync(){
      var i = trackIndex(track); if (i === cur) return; cur = i; if (i > 0 || touched) hyd(i);
      Array.prototype.forEach.call(el.querySelectorAll("[data-dot]"), function(d, k){ d.setAttribute("aria-current", k === i ? "true" : "false"); });
      var c = el.querySelector(".gs-count"); if (c) c.textContent = (i+1) + " / " + n;
      var pv = el.querySelector(".gs-prev"), nx = el.querySelector(".gs-next");
      if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i === n - 1;
      // zoom hint: top-left on caption-less slides (posters: bottom-left holds their IG handle), bottom-left when a caption pill is top-left
      el.classList.toggle("gs-cap-on", !!el.querySelector('.gs-slide[data-i="'+i+'"] .gs-caption'));
      if (opts.onChange) opts.onChange(i);
    }
    var raf = 0;
    track.addEventListener("scroll", function(){ if (!raf) raf = requestAnimationFrame(function(){ raf = 0; sync(); }); }, {passive: true});
    // M6 (2026-10-03): a swipe that starts on the arrow buttons / dots (not the scrolling track) used to do nothing and let mobile Chrome
    // treat it as a back-swipe. Those controls are touch-action:pan-y (styles.css), and the swipe is handled here for the whole slider.
    var sw = null, swiped = 0;
    el.addEventListener("touchstart", function(e){ sw = (e.touches.length === 1 && !track.contains(e.target)) ? {x: e.touches[0].clientX, y: e.touches[0].clientY} : null; }, {passive: true});
    el.addEventListener("touchend", function(e){
      if (!sw || !e.changedTouches.length) return; var dx = e.changedTouches[0].clientX - sw.x, dy = e.changedTouches[0].clientY - sw.y; sw = null;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      swiped = Date.now(); wake(); scrollToIdx(track, Math.max(0, Math.min(n - 1, trackIndex(track) + (dx < 0 ? 1 : -1))), true);
    }, {passive: true});
    el.addEventListener("click", function(e){
      var t;
      if (Date.now() - swiped < 500){ e.preventDefault(); return; }   // no extra arrow "click" right after a swipe
      wake();
      if ((t = e.target.closest(".gs-prev"))) return scrollToIdx(track, Math.max(0, trackIndex(track) - 1), true);
      if ((t = e.target.closest(".gs-next"))) return scrollToIdx(track, Math.min(n - 1, trackIndex(track) + 1), true);
      if ((t = e.target.closest("[data-dot]"))) return scrollToIdx(track, +t.getAttribute("data-dot"), true);
      if ((t = e.target.closest(".gs-open"))) { if (items[+t.getAttribute("data-i")].src) zoom(items, +t.getAttribute("data-i"), function(i){ scrollToIdx(track, i, false); }); }
    });
    track.addEventListener("keydown", function(e){
      wake();
      if (e.key === "ArrowRight") { e.preventDefault(); scrollToIdx(track, Math.min(n - 1, trackIndex(track) + 1), true); }
      if (e.key === "ArrowLeft") { e.preventDefault(); scrollToIdx(track, Math.max(0, trackIndex(track) - 1), true); }
    });
    window.addEventListener("resize", function onR(){ if (!el.isConnected) return window.removeEventListener("resize", onR); if (cur >= 0) scrollToIdx(track, cur, false); });
    requestAnimationFrame(sync);
    return {
      goTo: function(i, smooth){ if (i >= 0 && i < n){ hyd(i); scrollToIdx(track, i, smooth !== false); } },
      index: function(){ return trackIndex(track); }
    };
  }

  // ---------------- full-screen zoom viewer ----------------
  function zoom(items, start, onClose){
    var n = items.length, lastFocus = document.activeElement;
    var ov = document.createElement("div");
    ov.className = "gz"; ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "相片放大 Photo zoom");
    ov.innerHTML = '<div class="gz-track">' + items.map(function(it, i){
        return '<div class="gz-slide" data-i="'+i+'"><div class="gz-img">'+picture(it, Math.abs(i - start) <= 1)+'</div></div>';
      }).join("") + '</div>' +
      '<button type="button" class="gz-close" aria-label="關閉 Close">×</button>' +
      (n > 1 ? '<button type="button" class="gz-nav gz-prev" aria-label="上一張 Previous">‹</button><button type="button" class="gz-nav gz-next" aria-label="下一張 Next">›</button>' : '') +
      '<div class="gz-bar"><span class="gz-count"></span></div>' +
      '<p class="gz-hint">雙擊／兩指放大 · Double-tap or pinch to zoom</p>';
    document.body.appendChild(ov);
    var prevOverflow = document.body.style.overflow; document.body.style.overflow = "hidden";
    var track = ov.querySelector(".gz-track");
    var S = {scale: 1, x: 0, y: 0}, active = null;
    function imgOf(i){ return ov.querySelectorAll(".gz-img")[i]; }
    function apply(){ if (active) active.style.transform = "translate(" + S.x + "px," + S.y + "px) scale(" + S.scale + ")"; }
    function clamp(){
      if (!active) return;
      var r = active.parentNode.getBoundingClientRect();
      var mx = (r.width * (S.scale - 1)) / 2, my = (r.height * (S.scale - 1)) / 2;
      S.x = Math.max(-mx, Math.min(mx, S.x)); S.y = Math.max(-my, Math.min(my, S.y));
    }
    function setZoomed(on){ ov.classList.toggle("zoomed", on); }
    function reset(){ S = {scale: 1, x: 0, y: 0}; apply(); setZoomed(false); }
    function cur(){ return trackIndex(track); }
    function update(){
      var i = cur(); if (active !== imgOf(i)) { reset(); active = imgOf(i); }
      ov.querySelector(".gz-count").textContent = n > 1 ? (i + 1) + " / " + n : "";
      var pv = ov.querySelector(".gz-prev"), nx = ov.querySelector(".gz-next");
      if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i === n - 1;
      // load neighbours
      [i - 1, i + 1].forEach(function(k){ var im = imgOf(k) && imgOf(k).querySelector("img"); if (im) im.loading = "eager"; });
    }
    function go(i){ reset(); scrollToIdx(track, Math.max(0, Math.min(n - 1, i)), true); }
    function zoomAt(clientX, clientY, to){
      var r = active.parentNode.getBoundingClientRect();
      var cx = clientX - (r.left + r.width / 2), cy = clientY - (r.top + r.height / 2);
      var k = to / S.scale;
      S.x = cx - (cx - S.x) * k; S.y = cy - (cy - S.y) * k; S.scale = to;
      if (S.scale <= 1.01) return reset();
      clamp(); apply(); setZoomed(true);
    }
    // touch: pinch, pan, double-tap
    var t0 = null, lastTap = 0, lastTapXY = null;
    function dist(a, b){ return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    ov.addEventListener("touchstart", function(e){
      if (!active || e.target.closest("button")) return;
      if (e.touches.length === 2){
        e.preventDefault();
        var a = e.touches[0], b = e.touches[1];
        t0 = {mode: "pinch", d: dist(a, b), scale: S.scale, mx: (a.clientX + b.clientX) / 2, my: (a.clientY + b.clientY) / 2, x: S.x, y: S.y};
        setZoomed(true);
      } else if (e.touches.length === 1 && S.scale > 1){
        t0 = {mode: "pan", sx: e.touches[0].clientX, sy: e.touches[0].clientY, x: S.x, y: S.y};
      } else t0 = {mode: "tap", sx: e.touches[0].clientX, sy: e.touches[0].clientY, t: Date.now()};
    }, {passive: false});
    ov.addEventListener("touchmove", function(e){
      if (!t0) return;
      if (t0.mode === "pinch" && e.touches.length === 2){
        e.preventDefault();
        var a = e.touches[0], b = e.touches[1], r = active.parentNode.getBoundingClientRect();
        var ns = Math.max(1, Math.min(4, t0.scale * dist(a, b) / t0.d));
        var cx = t0.mx - (r.left + r.width / 2), cy = t0.my - (r.top + r.height / 2), k = ns / t0.scale;
        S.scale = ns; S.x = cx - (cx - t0.x) * k + ((a.clientX + b.clientX) / 2 - t0.mx); S.y = cy - (cy - t0.y) * k + ((a.clientY + b.clientY) / 2 - t0.my);
        clamp(); apply();
      } else if (t0.mode === "pan" && e.touches.length === 1){
        e.preventDefault();
        S.x = t0.x + e.touches[0].clientX - t0.sx; S.y = t0.y + e.touches[0].clientY - t0.sy; clamp(); apply();
      } else if (t0.mode === "tap"){
        if (Math.abs(e.touches[0].clientX - t0.sx) > 10 || Math.abs(e.touches[0].clientY - t0.sy) > 10) t0 = null;
      }
    }, {passive: false});
    ov.addEventListener("touchend", function(e){
      if (!t0) return;
      if (t0.mode === "pinch" && e.touches.length < 2){ if (S.scale <= 1.05) reset(); t0 = null; return; }
      if (t0.mode === "tap" && Date.now() - t0.t < 300){
        var now = Date.now();
        if (now - lastTap < 320 && lastTapXY && Math.abs(lastTapXY[0] - t0.sx) < 30 && Math.abs(lastTapXY[1] - t0.sy) < 30){
          e.preventDefault(); zoomAt(t0.sx, t0.sy, S.scale > 1 ? 1 : 2.5); lastTap = 0;
        } else { lastTap = now; lastTapXY = [t0.sx, t0.sy]; }
      }
      if (e.touches.length === 0) t0 = null;
    });
    // mouse: double-click zoom, drag to pan, wheel zoom
    ov.addEventListener("dblclick", function(e){ if (active && !e.target.closest("button")) zoomAt(e.clientX, e.clientY, S.scale > 1 ? 1 : 2.5); });
    var drag = null;
    ov.addEventListener("mousedown", function(e){ if (S.scale > 1 && !e.target.closest("button")){ e.preventDefault(); drag = {sx: e.clientX, sy: e.clientY, x: S.x, y: S.y}; } });
    function mm(e){ if (!drag) return; S.x = drag.x + e.clientX - drag.sx; S.y = drag.y + e.clientY - drag.sy; clamp(); apply(); }
    function mu(){ drag = null; }
    window.addEventListener("mousemove", mm); window.addEventListener("mouseup", mu);
    ov.addEventListener("wheel", function(e){ if (!active) return; e.preventDefault(); zoomAt(e.clientX, e.clientY, Math.max(1, Math.min(4, S.scale * (e.deltaY < 0 ? 1.15 : 0.87)))); }, {passive: false});
    var raf = 0;
    track.addEventListener("scroll", function(){ if (!raf) raf = requestAnimationFrame(function(){ raf = 0; update(); }); }, {passive: true});
    function close(){
      document.removeEventListener("keydown", onKey); window.removeEventListener("mousemove", mm); window.removeEventListener("mouseup", mu);
      document.body.style.overflow = prevOverflow; var i = cur(); ov.remove();
      if (onClose) onClose(i);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({preventScroll: true}); } catch(e){}
    }
    function onKey(e){
      if (e.key === "Escape") close();
      else if (e.key === "ArrowRight") go(cur() + 1);
      else if (e.key === "ArrowLeft") go(cur() - 1);
    }
    document.addEventListener("keydown", onKey);
    ov.querySelector(".gz-close").addEventListener("click", close);
    var p = ov.querySelector(".gz-prev"), x = ov.querySelector(".gz-next");
    if (p) p.addEventListener("click", function(){ go(cur() - 1); });
    if (x) x.addEventListener("click", function(){ go(cur() + 1); });
    scrollToIdx(track, start, false);
    requestAnimationFrame(function(){ scrollToIdx(track, start, false); update(); ov.querySelector(".gz-close").focus({preventScroll: true}); });
    return {close: close};
  }

  window.NomariGallery = {slider: slider, zoom: zoom};
})();
